import CustomerDistribution from './customer_distribution.vue';

export default CustomerDistribution;
